// source: witbooking/backoffice/enginemulticonfig/v1/engine_multi_config_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.displayName = 'proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig;
      reader.readMessage(value,proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineMultiConfig configuration = 1;
 * @return {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig|undefined} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} returns this
*/
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig;
      reader.readMessage(value,proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineMultiConfig configuration = 1;
 * @return {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig|undefined} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} returns this
*/
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig;
      reader.readMessage(value,proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineMultiConfig configuration = 1;
 * @return {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig|undefined} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse} returns this
*/
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig;
      reader.readMessage(value,proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional EngineMultiConfig configuration = 1;
 * @return {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig|undefined} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse} returns this
*/
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configurationsList: jspb.Message.toObjectList(msg.getConfigurationsList(),
    proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig;
      reader.readMessage(value,proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinaryFromReader);
      msg.addConfigurations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigurationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EngineMultiConfig configurations = 1;
 * @return {!Array<!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig>}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.prototype.getConfigurationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig>} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse} returns this
*/
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.prototype.setConfigurationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.prototype.addConfigurations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.prototype.clearConfigurationsList = function() {
  return this.setConfigurationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serialized: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialized(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerialized();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string serialized = 1;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.prototype.getSerialized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.prototype.setSerialized = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    serialized: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest;
  return proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialized(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerialized();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string serialized = 1;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.prototype.getSerialized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest.prototype.setSerialized = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse;
  return proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    triggersList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    serialized: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig;
  return proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTriggers(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialized(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTriggersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getSerialized();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string triggers = 3;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.getTriggersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.setTriggersList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.addTriggers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.clearTriggersList = function() {
  return this.setTriggersList([]);
};


/**
 * optional string serialized = 4;
 * @return {string}
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.getSerialized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig} returns this
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfig.prototype.setSerialized = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.enginemulticonfig.v1);
